import { Utils } from "@/plugins/utils"
import router from "@/router"
import moment from "moment"

export default {
	namespaced: true,
	state: {
		lstLod: [],
		lstLoc: [],
		lod: {},
		loc: null,
		vigenPeriod: 0,
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 20,
		search: "",
		sinceDateVigen: moment().subtract(0, "months").startOf("month").format("YYYY-MM-DD 00:00"),
		untilDateVigen: moment().subtract(0, "months").endOf("month").format("YYYY-MM-DD 00:00"),
		hasNext: false,
		lastUpdatedRegister: null,
		statusFilter: 99,
	},
	getters: {
		getUpdate(state) {
			return state.update
		},
		getLod(state) {
			let lod = { ...state.lod }
			return lod
		},
		getSearch(state) {
			return state.search
		},
		getItemsPerPage(state) {
			return state.itemsPerPage
		},
	},
	mutations: {
		set(state, lod) {
			state.lod = lod || {}
			if (lod && lod.lodvigenc && lod.lodemissao) {
				const dataVigenc = new Date(lod.lodvigenc)
				const dataEmissao = new Date(lod.lodemissao)
				const anos = dataVigenc.getFullYear() - dataEmissao.getFullYear()
				const meses = dataVigenc.getMonth() - dataEmissao.getMonth()
				state.vigenPeriod = anos * 12 + meses
			}
			if (lod) state.update = true
		},
		initForm(state) {
			state.insert = false
			state.update = false
			state.lod = {}
		},
		setParamsDataTable(state, payload) {
			state.lstLod = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
		setLoading(state, loading) {
			state.loading = loading
		},
		setLod(state, lod) {
			state.lod = lod
		},
		setLstLod(state, lstLod) {
			state.lstLod = lstLod
		},
		setHasNext(state, hasNext) {
			state.hasNext = hasNext
		},
		setSearch(state, search) {
			state.search = search
		},
		setLastUpdatedRegister(state, lastUpdatedRegister) {
			state.lastUpdatedRegister = lastUpdatedRegister
		},
	},
	actions: {
		initForm({ commit }) {
			commit("initForm")
		},
		async findByCv5({ commit, dispatch }, { cv5doc, cv5tipo, cv5emissor }) {
			commit("setLoading", true)
			commit("initForm")
			await this._vm.$axios
				.get(`/Financial/LeaseDocument/FindByCv5/${cv5doc}/${cv5tipo}/${cv5emissor}`)
				.then(response => {
					let lod = Utils.ValidateAxiosResponse(response.data)
					commit("set", lod)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
				})
			commit("setLoading", false)
		},
		async find({ commit, dispatch }, {loddocid, loddoc, lodtipo, lodemissor }) {
			commit("setLoading", true)
			commit("initForm")
			await this._vm.$axios
				.get(`/Financial/LeaseDocument/Find/${loddocid}/${loddoc}/${lodtipo}/${lodemissor}`)
				.then(response => {
					let lod = Utils.ValidateAxiosResponse(response.data)
					commit("set", lod)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
				})
			commit("setLoading", false)
		},
		async get({ dispatch }, { loddocid }) {
			return await this._vm.$axios
				.get(`/Financial/LeaseDocument/Find/${loddocid}`)
				.then(response => {
					return Utils.ValidateAxiosResponse(response.data)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return null
				})
		},
		async save({ getters, dispatch }) {
			if (getters.getUpdate) {
				return await dispatch("update")
			}
			return await dispatch("insert")
		},
		async insert({ commit, dispatch }, lstLod) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true },
			)
			let payload = await this._vm.$axios
				.post("/Financial/LeaseDocument/Insert", lstLod)
				.then(response => {
					commit("setLastUpdatedRegister", Utils.ValidateAxiosResponse(response.data))
					commit("setLod", null)
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async update({ commit, dispatch }, lod) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true },
			)
			let payload = await this._vm.$axios
				.put("/Financial/LeaseDocument/Update", lod)
				.then(response => {
					commit("setLastUpdatedRegister", Utils.ValidateAxiosResponse(response.data))
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async delete({ dispatch }) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Excluindo", indeterminate: true },
				{ root: true },
			)
			await this._vm.$axios
				.delete("/Financial/LeaseDocument/Delete")
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
		},
		async findAllLod({ commit, dispatch }) {
			commit("setLoading", true)
			commit("initForm")
			await this._vm.$axios
				.get("/Financial/LeaseDocument/FindAllLod")
				.then(response => {
					let lstLod = Utils.ValidateAxiosResponse(response.data)
					commit("setLstLod", lstLod)
				})
				.catch(error => {
					commit("setLstLod", [])
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			commit("setLoading", false)
		},
		async retryLod({ commit, dispatch }, lod) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true },
			)
			let payload = await this._vm.$axios
				.put("/Financial/LeaseDocument/RetryLod", lod)
				.then(response => {
					commit("setLastUpdatedRegister", Utils.ValidateAxiosResponse(response.data))
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async searchLod({ commit, dispatch, state, getters }, { limit = 20, page = 1 } = {}) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Buscando documentos", indeterminate: true },
				{ root: true },
			)
			commit("setLoading", true)
			commit("initForm")

			let statusFilter = ""
			if (state.statusFilter || state.statusFilter == 0) {
				statusFilter += "&statusFilter=" + state.statusFilter
			} else {
				statusFilter += "&statusFilter=" + 99
			}

			let url = `/Financial/LeaseDocument/SearchLod?search=${getters.getSearch}&limit=${limit}&page=${page}`

			if (state.sinceDateVigen) {
				url += `&sinceDateVigen=${state.sinceDateVigen}`
			}
			if (state.untilDateVigen) {
				url += `&untilDateVigen=${state.untilDateVigen}`
			}
			url += `${statusFilter}`

			let payload = await this._vm.$axios
				.get(url)
				.then(response => {
					let payload = Utils.ValidateAxiosResponse(response.data)
					commit("setParamsDataTable", payload)
					return true
				})
				.catch(error => {
					commit("setLstLod", [])
					commit("setSearch", "")
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			commit("setLoading", false)
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async sendLeaseEmail(store, { lod, silent = false }) {
			store.dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Enviando dados da locação por e-mail...", indeterminate: true },
				{ root: true },
			)
			let payload = await this._vm.$axios
				.post(`/Financial/LeaseDocument/SendLeaseEmail`, lod)
				.then(response => {
					let message = Utils.ValidateAxiosResponse(response.data)
					if (!silent) {
						store.dispatch(
							"parameters/openDialog",
							{
								titleText: message,
								titleColor: "green",
							},
							{ root: true },
						)
					}
					return true
				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
	},
}
